export default [
  {
    path: '/signatures',
    name: 'signature',
    meta: { requiresAuth: true },
    component: () => import('@/pages/signature/index-v2.vue')
  }
]
